import { Star, ShieldCheck, MapPin } from "lucide-react";
import { IMAGES, BUSINESS } from "@/data";

export const Hero = () => {
  const scrollToQuote = () => document.querySelector("#quote")?.scrollIntoView({ behavior: "smooth" });
  const scrollToServices = () => document.querySelector("#services")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="top" className="relative min-h-screen flex items-center bg-ink overflow-hidden">
      <div className="absolute inset-0">
        <img src={IMAGES.hero} alt="Home with sparkling clean windows" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/90 to-ink/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-transparent to-ink/60" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 pt-28 pb-20 w-full">
        <div className="max-w-2xl animate-fade-up">
          <div className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.2em] text-brand">
            <MapPin size={14} strokeWidth={2} /> Castle Rock · Larkspur · Parker
          </div>

          <h1 className="mt-6 font-display font-extrabold text-white text-5xl md:text-6xl lg:text-7xl tracking-tight leading-[1.05]">
            Clear Views.
            <br />
            <span className="text-brand">Better Spaces.</span>
          </h1>

          <p className="mt-6 text-lg md:text-xl text-slate-300 leading-relaxed max-w-xl">
            Professional window, gutter & solar panel cleaning for homes and businesses across Colorado's Front Range. Streak-free results, every time.
          </p>

          <div className="mt-9 flex flex-col sm:flex-row gap-4">
            <button
              data-testid="hero-quote-button"
              onClick={scrollToQuote}
              className="rounded-xl bg-brand hover:bg-brand-hover text-white font-semibold px-8 py-4 text-base transition-all duration-300 hover:-translate-y-1 shadow-xl shadow-brand/30"
            >
              Get Your Free Quote
            </button>
            <button
              data-testid="hero-services-button"
              onClick={scrollToServices}
              className="rounded-xl border border-white/20 bg-white/5 hover:bg-white/10 text-white font-semibold px-8 py-4 text-base transition-all duration-300"
            >
              View Services
            </button>
          </div>

          <div className="mt-12 flex flex-wrap items-center gap-x-8 gap-y-4 text-sm text-slate-300">
            <div className="flex items-center gap-2">
              <div className="flex text-brand">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" strokeWidth={0} />)}
              </div>
              <span className="font-medium text-white">5.0 ★ · 131 Google reviews</span>
            </div>
            <div className="flex items-center gap-2">
              <ShieldCheck size={18} strokeWidth={1.5} className="text-brand" />
              <span>Fully insured & satisfaction guaranteed</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
